import React from 'react';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import moment from 'moment';
import HttpClient from 'services/HttpClient';

const EVENTBRITE_REQUEST = '/api/v1/events';

@withRouter
export default class LiveEvents extends React.Component {
  state = {
    eventbrite: []
  }

  componentDidMount() {
    new HttpClient().get(EVENTBRITE_REQUEST).then(response => {
      let liveEvents = response.body.events.filter(event => {
        return event.attrs.attrs.status === 'live'
      });
      liveEvents = liveEvents.map(event => {
        return event = event.attrs.attrs
      })
      this.setState({
        ...this.state,
        eventbrite: liveEvents
      })
    });
  }

  showEvents = () => {
    return this.state.eventbrite.map((event, idx) => {
      return (
        <div className="eventbrite-widg" key={idx}>
          <h3>{event.name.text}</h3>
          <span className="date">{moment(event.start.utc).format('MMM Do YY, h:mm a')} - {moment(event.end.utc).format('MMM Do YY, h:mm a')}</span>
          <p className="desc">{event.summary}</p>
          <a href={event.url} target='_blank'><button>Event datails</button></a>
        </div>
      )
    })
  }

  render() {
    return (
      <section className="contact-us section-center">
        <div className="section-center-wrapper">
          <div className="hero-block">
            <h3 className="title">Live Events</h3>
          </div>
          <div className="dashboard-container" style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
            <div className="col-10 col-md-3 events-container" style={{ maxWidth: '80%', flex: 1 }}>
              {!_.isEmpty(this.state.eventbrite) && this.showEvents()}
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/informations/LiveEvents.js